export default {"src":"/_next/static/media/cz.2dec2aa9.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};